import React from 'react';
import { Switch, Route, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import Home from './components/Home';
import Demo from './components/Demo';
import Everest from './components/Everest';
import TripDetails from './components/TripDetails';
import Booking from './components/Booking';
import OurStory from './components/OurStory';
import Help from './components/Help';
import FAQ from './components/FAQ';
import ThankYou from './components/Help/ThankYou';
import BookingSummary from './components/Booking/BookingSummary';
import BookingCompanions from './components/Booking/BookingCompanions';
import TermsAndConditions from './components/TermsAndConditions';
import PrivacyDisclaimer from './components/PrivacyDisclaimer';
import MyBookings from './components/MyBookings';
import MyBookingDetails from './components/MyBookings/BookingDetails';
import EditCompanions from './components/MyBookings/EditCompanions';
import ChangePassword from './components/MyBookings/ChangePassword';
import Review from './components/Reviews';
import Auth from './components/Auth';
import PrivateRoute from './components/utility/PrivateRoute';
import ErrorDisplay from './components/utility/ErrorDisplay';
import { PropTypes } from 'prop-types';
import Verify from './components/Auth/Verify';
import Contest from './components/Contest';

const notFoundError = {
  response: {
    status: 404
  }
};

const Routes = ({ signedIn, authType }) => (
  <div className='fe-content-container'>
    <Switch>
      {/* To add trailing slash */}
      {/* <Route exact strict path="/:url*" render={props => <Redirect to={`${props.location.pathname}/`}/>} /> */}
      {/* To add trailing slash */}

      {/* <Route exact strict path='/' component={Home} /> */}
      <Route exact path='/' component={Home} />
      {/* <Route exact path='/demo' component={Demo} /> */}
      <Route exact path='/everest' component={Everest} />
      <Route exact path='/contest' component={Contest} />
      <Route exact path='/trips/:slug' component={TripDetails} />
      <Route exact path='/booking/summary' component={BookingSummary} />
      <Route exact path='/booking/companions' component={BookingCompanions} />
      <PrivateRoute
        exact
        path='/booking/:slug/:uuid'
        component={Booking}
        condition={signedIn}
        redirectUrl='/login'
      />
      <Route exact path='/booking/:slug' component={Booking} />
      <Route exact path='/thank-you' component={ThankYou} />
      <Route exact path='/our-story' component={OurStory} />
      <Route
        exact
        path='/terms-and-conditions'
        component={TermsAndConditions}
      />
      <Route
        exact
        path='/privacy-disclaimer'
        component={PrivacyDisclaimer}
      />
      <Route exact path='/help-and-support' component={Help} />
      <Route exact path='/faq' component={FAQ} />
      {/* <Route exact path='/your-bookings' component={MyBookings} /> */}
      <PrivateRoute
        exact
        path='/your-bookings'
        component={MyBookings}
        condition={signedIn}
        redirectUrl='/login'
      />
      <PrivateRoute
        exact
        path='/your-bookings/:slug'
        component={MyBookingDetails}
        condition={signedIn}
        redirectUrl='/login'
      />
      <PrivateRoute
        exact
        path='/your-bookings/edit/:slug'
        component={EditCompanions}
        condition={signedIn}
        redirectUrl='/login'
      />
      <PrivateRoute
        exact
        path='/leave-a-review/:uuid'
        component={Review}
        condition={signedIn}
        redirectUrl='/login'
      />
      <Route
        exact
        path='/leave-public-review/:uuid'
        render={props => <Review public {...props} />}
      />
      <PrivateRoute
        exact
        path='/change-password'
        // component={ChangePassword}
        component={() => {
          window.location.href = '/change-password?uri=' + process.env.APP_URL + '/getaways';
          return null;
        }}
        condition={signedIn && authType === 'Standard'}
        redirectUrl='/login'
      />
      <PrivateRoute
        exact
        path='/signup'
        // component={() => <Auth authType='signup' />}
        component={() => {
          window.location.href = '/signup?uri=' + process.env.APP_URL + '/getaways';
          return null;
        }}
        condition={!signedIn}
        redirectUrl='/'
      />
      <PrivateRoute
        exact
        path='/login'
        // component={() => <Auth authType='login' />}
        component={() => {
          window.location.href = '/login?uri=' + process.env.APP_URL + '/getaways';
          return null;
        }}
        condition={!signedIn}
        redirectUrl='/'
      />
      <PrivateRoute
        exact
        path='/verify-account'
        component={() => <Auth authType='verify' />}
        // component={() => <Verify />}
        condition={!signedIn}
        redirectUrl='/'
      />
      <PrivateRoute
        exact
        path='/forgot-password'
        // component={() => <Auth authType='resetPassword' />}
        component={() => {
          window.location.href = '/forgot-password?uri=' + process.env.APP_URL + '/getaways';
          return null;
        }}
        condition={!signedIn}
        redirectUrl='/'
      />
      <Route render={() => <ErrorDisplay error={notFoundError} />} />
    </Switch>
  </div>
);

Routes.propTypes = {
  signedIn: PropTypes.bool.isRequired,
  authType: PropTypes.string.isRequired,
  location: PropTypes.object
};

const mapStateToProps = ({ authState }) => ({
  signedIn: authState.signedIn,
  authType: authState.authType
});

export default connect(mapStateToProps)(Routes);
